import { render } from "./SingleChannel.vue?vue&type=template&id=76063bd6"
import script from "./SingleChannel.vue?vue&type=script&lang=js"
export * from "./SingleChannel.vue?vue&type=script&lang=js"

import "./SingleChannel.vue?vue&type=style&index=0&id=76063bd6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__